import BgDocument from "../assets/legality.png";
import Center from "../assets/student-3.png";

const LegalityPage = () => {
  return (
    <div className="min-h-screen bg-gray-100 font-sans text-gray-800 flex flex-col items-center">
      <img src={BgDocument} alt="Logo" width="100%" />
      <img src={Center} alt="Logo" width="100%" />
    </div>
  );
};

export default LegalityPage;
